// src/shared/components/layout/MainLayout.tsx

import React from 'react';
import { useAppContext } from '../../context/AppContext';
import Header from './Header';
import Sidebar from './Sidebar';
import './MainLayout.css';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { state } = useAppContext();
  const { auth } = state;
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  // Si no está autenticado, renderizar solo el contenido (página de login)
  if (!auth.isAuthenticated) {
    return (
      <div className="app-wrapper">
        {children}
      </div>
    );
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Si está autenticado, renderizar layout completo con header y sidebar
  return (
    <div className="main-layout">
      <Header onToggleSidebar={toggleSidebar} />
      
      <div className="layout-body">
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={closeSidebar}
        />
        
        <main className="main-content">
          <div className="content-wrapper">
            {children}
          </div>
        </main>
      </div>

      {/* Overlay para cerrar sidebar en móvil */}
      {sidebarOpen && (
        <div 
          className="sidebar-overlay"
          onClick={closeSidebar}
        />
      )}
    </div>
  );
};

export default MainLayout;